import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GraduationCap, ChevronRight } from 'lucide-react';
import { fetchMySummaryThunk } from '../../redux/credentialQuiz/credentialQuizActionThunks';
import { selectKnowledgeSummary } from '../../redux/credentialQuiz/credentialQuizSlice';

// Compact profile-page summary for the standalone Knowledge Assessment
// system -- deliberately visually and structurally separate from
// GuardrailTierPanel/CredibilityExplainer above it, since this data has no
// bearing on credibility score or monetization tier (see
// credential_quiz_model.py's own docstring for why that's a deliberate
// design choice, not an oversight).
const KnowledgeAssessmentSummary = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const summary = useSelector(selectKnowledgeSummary);

  useEffect(() => {
    if (!summary) dispatch(fetchMySummaryThunk());
  }, [dispatch, summary]);

  const pct = summary && summary.topic_mastery_max_possible > 0
    ? Math.round((summary.topic_mastery_score / summary.topic_mastery_max_possible) * 100)
    : 0;

  return (
    <Link
      to="/knowledge-quiz"
      className="block bg-cream-100 dark:bg-white/5 border border-cream-300 dark:border-white/10 rounded-2xl p-5 hover:border-violet-500/40 transition-colors"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <GraduationCap className="w-5 h-5 text-violet-600 dark:text-violet-400" />
          <h3 className="text-base font-semibold text-cream-900 dark:text-white">{t('credibility.knowledgeAssessment.title')}</h3>
        </div>
        <ChevronRight className="w-4 h-4 text-cream-700 dark:text-gray-500" />
      </div>
      {summary ? (
        <>
          <p className="text-sm text-cream-700 dark:text-gray-400 mt-1">
            {t('credibility.knowledgeAssessment.progressSummary', { attempted: summary.topics_attempted, available: summary.topics_available, pct })}
          </p>
          <div className="mt-3 w-full bg-cream-300 dark:bg-gray-700/50 rounded-full h-1.5 overflow-hidden">
            <div className="h-1.5 rounded-full bg-gradient-to-r from-violet-500 to-indigo-500" style={{ width: `${pct}%` }} />
          </div>
        </>
      ) : (
        <p className="text-sm text-cream-700 dark:text-gray-500 mt-1">{t('credibility.knowledgeAssessment.promo')}</p>
      )}
    </Link>
  );
};

export default KnowledgeAssessmentSummary;
